<template>
  <v-container fill-height justify-center>
    <div>
      <v-card outlined max-width="350" class="pa-4 text-center" rounded="lg">
        <v-card-text>
          <v-img
            max-height="100"
            contain
            alt="IMSO"
            :src="require('@/assets/logo.png')"
            class="ma-auto"
          />
          <div class="text-h6">Verify Email</div>

          <div class="mt-3">Please check your email</div>
          <div class="mb-5 text-caption">
            We have sent a code to {{ auth.email }}
          </div>
          <v-otp-input
            @finish="checkOtp()"
            v-model="otp"
            autofocus
            focusable
            focused
          ></v-otp-input>
          <div>
            Didn't get the code?
            <a @click="resendOtp">Click to resend</a>
            <v-progress-circular
              v-if="resentLoading"
              class="mx-1"
              size="10"
              width="1"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>

          <v-row class="mt-1">
            <v-col>
              <v-btn
                text
                color="secondary"
                depressed
                block
                class="text-capitalize"
                @click="goBack()"
              >
                Back
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                depressed
                block
                class="primary text-capitalize"
                @click="checkOtp()"
                :loading="loading"
              >
                Verify
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-sheet flat max-width="350" color="transparent" class="text-right mt-2">
        <v-btn
          text
          x-small
          color="grey"
          class="text-capitalize"
          link
          href="https://openesrilanka.org/"
          target="blank"
        >
          Help
        </v-btn>
        <v-btn
          text
          x-small
          color="grey"
          class="text-capitalize"
          link
          href="https://openesrilanka.org/"
          target="blank"
        >
          Privacy
        </v-btn>
        <v-btn
          text
          x-small
          color="grey"
          class="text-capitalize"
          link
          href="https://openesrilanka.org/"
          target="blank"
        >
          Terms
        </v-btn>
      </v-sheet>
    </div>
  </v-container>
</template>
    
    <script>
import { mapState } from "vuex";
import { sentOTP, checkOTP } from "@/services/authService";
export default {
  components: {
    //
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    resentLoading: false,
    email: "",
    otp: "",
    loading: false,
  }),
  created() {
    //
  },
  mounted() {
    //
  },
  methods: {
    goBack() {
      this.$router.push({ name: "PageAuthSignin" });
    },
    goHome() {
      this.$router.push({ name: "PageDashboard" });
    },
    async checkOtp() {
      this.loading = true;
      let checkOTPReturn = await checkOTP({
        email: this.auth.email,
        otp: this.otp,
      });
      this.loading = false;
      if (checkOTPReturn == "success") {
        this.goHome();
      }
    },
    async resendOtp() {
      if (this.auth.email) {
        this.resentLoading = true;
        await sentOTP({ email: this.auth.email });
        this.resentLoading = false;
      } else {
        this.goBack();
      }
    },
  },
};
</script>